import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { LoginService } from '../login/login.service';
import { LoggerService } from 'src/app/logger.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatorService } from 'src/app/translator.service';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.page.html',
  styleUrls: ['./demo.page.scss'],
})
export class DemoPage implements OnInit {
  token: any;
  startdate: any;
  accountid: any;
  showpasswordfield: boolean = false;
  passwordvalue = "";
  constructor(private route: ActivatedRoute, private navCtrl: NavController, private router: Router, private loginService: LoginService, private logger: LoggerService, public translator:TranslatorService) {

    this.route.queryParams.subscribe(params => {
      if (params && params.token) {
        this.token = params.token;
      }
      if (params && params.date) {
        this.startdate = params.date;
      }
      if (params && params.accountid) {
        this.accountid = params.accountid;
      }
      this.checkLinkIsValid()
    });

  }
  async checkLinkIsValid() {
    let isValid: any = await this.loginService.isTokenValid(this.accountid, this.token, this.startdate);
    if (isValid && isValid.data === "success") {
      this.showpasswordfield = true;
    }
  }
  async recoverPassword() {
    await this.loginService.updatePassword(this.accountid, this.passwordvalue, this.token).then(async (data: any) => {
      if (data.data === 'success') {
        this.router.navigateByUrl("/auth/tabs/login");
      } else {
        alert("Am întâmpinat o eroare, parola Dvs. nu a putut fi modificată. Link-ul primit prin email a expirat! Vă rugăm să solicitați din nou resetarea parolei și să urmați pașii din email.")
       }
    });
  }
  ngOnInit() {

  }

}
